import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductExperience } from '../components/ProductExperience';
import { CompetitiveEdge } from '../components/CompetitiveEdge';
import { CaseStudy } from '../components/CaseStudy';
import { LeadershipSection } from '../components/LeadershipSection';
import { FinalCTA } from '../components/FinalCTA';
import { SiteFooter } from '../components/ui/SiteFooter';
import { SiteHeader } from '../components/ui/SiteHeader';
export function FemEntityLanding() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-822" data-mp="rtgrk9jbfavn">
      <SiteHeader variant="overlay" currentPath="/" showPartnerButton data-id="element-823" data-mp="my1h7rkinx3z" />

      <Hero data-id="element-824" data-mp="3cm2367k4rfb7" />
      <ProblemSection data-id="element-825" data-mp="3cmk9jx0ib9wu" />
      <CaseStudy data-id="element-826" data-mp="3ciwgeyyz4pin" />
      <SolutionSection data-id="element-827" data-mp="37mfp5vwh9v1c" />
      <ProductExperience data-id="element-828" data-mp="37l4o43uf31dx" />
      <CompetitiveEdge data-id="element-829" data-mp="37kl84sobun2j" />
      <LeadershipSection data-id="element-830" data-mp="37oipb8rch4js" />
      <FinalCTA data-id="element-831" data-mp="3eyyfhjjbwyld" />

      <SiteFooter currentPath="/" data-id="element-832" data-mp="3f0j8v5twqbhn" />
    </main>;
}